import { useMediaQuery } from '@mui/material'
import { useTheme } from '@mui/material/styles'

const useIsMobile = () => {
  const theme = useTheme()
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  const isSmDown = useMediaQuery(theme.breakpoints.down('sm'))
  //const isMobile = /android|iphone|windows phone/i.test(userAgent) || isSmDown;
  return isSmDown
}

export default useIsMobile
